import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import { LanguageProvider } from "@/contexts/LanguageContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import Navbar from "@/components/marketing/Navbar";
import Footer from "@/components/marketing/Footer";
import HomePage from "@/pages/HomePage";
import SolutionsPage from "@/pages/SolutionsPage";
import EngagementsPage from "@/pages/EngagementsPage";
import ContactPage from "@/pages/ContactPage";
import LoginPage from "@/pages/LoginPage";
import CasReelsPage from "@/pages/CasReelsPage";
import EditorPage from "@/pages/dashboard/EditorPage";
import DashboardLayout from "@/pages/dashboard/DashboardLayout";
import DashboardOverview from "@/pages/dashboard/DashboardOverview";
import RecallsPage from "@/pages/dashboard/RecallsPage";
import DlcPage from "@/pages/dashboard/DlcPage";
import AlertsPage from "@/pages/dashboard/AlertsPage";
import CompliancePage from "@/pages/dashboard/CompliancePage";
import PurchasesPage from "@/pages/dashboard/PurchasesPage";

function MarketingLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/" element={<MarketingLayout><HomePage /></MarketingLayout>} />
          <Route path="/solutions" element={<MarketingLayout><SolutionsPage /></MarketingLayout>} />
          <Route path="/engagements" element={<MarketingLayout><EngagementsPage /></MarketingLayout>} />
          <Route path="/contact" element={<MarketingLayout><ContactPage /></MarketingLayout>} />
          <Route path="/cas-reels" element={<MarketingLayout><CasReelsPage /></MarketingLayout>} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/dashboard" element={<ProtectedRoute><><Navbar /><DashboardLayout /></></ProtectedRoute>}>
            <Route index element={<DashboardOverview />} />
            <Route path="recalls" element={<RecallsPage />} />
            <Route path="dlc" element={<DlcPage />} />
            <Route path="alerts" element={<AlertsPage />} />
            <Route path="compliance" element={<CompliancePage />} />
            <Route path="purchases" element={<PurchasesPage />} />
            <Route path="editor" element={<EditorPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
